import { createSlice } from '@reduxjs/toolkit';
import { initStateSendBroadcast, reducerSendBroadcast } from '../actions/broadcast/sendBroadcast';
import { initStateSendCandidateList, reducerSendCandidateList } from '../actions/broadcast/sendCandidateList';
import { initStateGetCandidateList, reducerGetCandidateList } from '../actions/broadcast/getCandidateList';
import { initStateClearCandidateList, reducerClearCandidateList } from '../actions/broadcast/clearCandidateList';

export const initialState = {
  ...initStateSendBroadcast,
  ...initStateSendCandidateList,
  ...initStateGetCandidateList,
  ...initStateClearCandidateList,
};

export const broadcastSlice = createSlice({
  name: 'broadcast',
  initialState,
  reducers: {
    resetSendBroadcast(state, action) {
      state.sendBroadcast = initStateSendBroadcast.sendBroadcast;
    },
    resetSendCandidateList(state, action) {
      state.sendCandidateList = initStateSendCandidateList.sendCandidateList;
    },
    resetGetCandidateList(state, action) {
      state.getCandidateList = initStateGetCandidateList.getCandidateList;
    },
    resetClearCandidateList(state, action) {
      state.clearCandidateList = initStateClearCandidateList.clearCandidateList;
    },
  },
  extraReducers: {
    ...reducerSendBroadcast,
    ...reducerSendCandidateList,
    ...reducerGetCandidateList,
    ...reducerClearCandidateList,
  },
});
export const { resetClearCandidateList, resetGetCandidateList, resetSendBroadcast, resetSendCandidateList } = broadcastSlice.actions;
export const broadcastReducer = broadcastSlice.reducer;
